import { metricUrlCodes, products, yaMetricsAbTestId, yaMetricsId } from "../constants/metrics";
import getCurrentEnvironment from "./getCurrentEnvironment";

const sendMetric = (target, product, type) => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  if (window && window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({ event: target, product, options: { type } });
  }
};

// TODO: заменить обращение к обьекту на типизацию, чтобы исключить расширение конечного бандла
// sendDataLakeEvent
export const sendNavigationMetric = (key) => {
  if (!metricUrlCodes[key]) {
    console.error("Can't find navigation metric key. Key", key);

    return;
  }

  sendMetric(metricUrlCodes[key], products.NAVIGATION);
};

/**
 * Запускает AB тесты
 * @param {Record<Flag, (values: FlagValues) => void>} handlers Обработчики флагов
 */
export const startAbTest = handlers => {
  if (getCurrentEnvironment() !== "production") {
    const pageParams = new URLSearchParams(window.location.search);

    setTimeout(() => {
      pageParams.forEach((value, key) => {
        // Для тестового окружения передаем значение как одноэлементный массив
        // для совместимости с обработкой в production
        const handler = handlers?.[key];
        if (handler) handler([value]);
      });
    }, 500);
  } else {
    window.ymab?.(yaMetricsAbTestId, "getFlags", flags => {
      Object.entries(flags).forEach(([flag, values]) => {
        const handler = handlers[flag];
        if (handler && Array.isArray(values)) {
          // Передаем все значения варианта в обработчик
          handler(values);
        }
      });
    });
  }
};

/**
 * Отправляет параметры пользователя в Яндекс Метрику
 * @param {Object} params - Объект с параметрами пользователя
 */
export const sendUserParamsToMetrics = (params) => {
  if (window.ym) {
    window.ym(yaMetricsId, "userParams", params);
  } else if (getCurrentEnvironment() !== "production") {
    console.log("Yandex Metrics not available, but would send:", params);
  }
};

export default sendMetric;
